export default {
  LIST_FETCHED: 'LOTTIES_FETCHED',
  LIST_LOAD: 'LOTTIES_LOAD',
  ITEM_DETAIL: 'LOTTIES_DETAIL',
  BUTTON_LOAD: 'LOTTIES_BUTTON_LOAD',
};
